/**
 * Composable per gestire lo stato del menu attivo a livello globale
 * Permette di impostare dinamicamente quale voce di menu è attiva
 *
 * Usa useState per garantire la sincronizzazione tra server e client (SSR-friendly)
 */

export const useActiveMenu = () => {
  // Path completo del menu item attivo (es: "/ccnl/index")
  const activeMenuPath = useState<string>('activeMenuPath', () => '')

  // Key del menu item attivo (es: "1-2-3" per item annidati)
  const activeMenuKey = useState<string>('activeMenuKey', () => '')

  // ID della categoria attiva (per i submenu CCNL)
  const activeCategoryId = useState<number | null>('activeCategoryId', () => null)

  /**
   * Imposta il menu attivo tramite il path della route
   */
  const setActiveMenuByPath = (path: string) => {
    console.log('useActiveMenu setActiveMenuByPath path: ', path)
    activeMenuPath.value = path
    // Reset degli altri stati quando si imposta un nuovo path
    activeMenuKey.value = ''
    activeCategoryId.value = null
  }

  /**
   * Imposta il menu attivo tramite la key
   */
  const setActiveMenuByKey = (key: string) => {
    activeMenuKey.value = key
  }

  /**
   * Imposta la categoria attiva (per submenu CCNL)
   */
  const setActiveCategoryId = (id: number | null) => {
    activeCategoryId.value = id
  }

  /**
   * Verifica se un path è attivo
   */
  const isPathActive = (path: string): boolean => {
    return activeMenuPath.value === path
  }

  /**
   * Verifica se una key è attiva
   */
  const isKeyActive = (key: string): boolean => {
    return activeMenuKey.value === key
  }

  /**
   * Verifica se una categoria è attiva
   */
  const isCategoryActive = (id: number): boolean => {
    return activeCategoryId.value === id
  }

  /**
   * Reset dello stato
   */
  const resetActiveMenu = () => {
    activeMenuPath.value = ''
    activeMenuKey.value = ''
    activeCategoryId.value = null
  }

  return {
    // State (come computed read-only per evitare modifiche dirette)
    activeMenuPath: readonly(activeMenuPath),
    activeMenuKey: readonly(activeMenuKey),
    activeCategoryId: readonly(activeCategoryId),

    // Methods
    setActiveMenuByPath,
    setActiveMenuByKey,
    setActiveCategoryId,
    isPathActive,
    isKeyActive,
    isCategoryActive,
    resetActiveMenu
  }
}